import { z } from "zod";
import { ROLES } from "../roles.js";

export const passwordSchema = z.string().min(10, "Almeno 10 caratteri").max(200);
export const emailSchema = z.string().trim().toLowerCase().email().max(254);

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(200),
  tenantId: z.string().uuid().optional(),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const registerSchema = z.object({
  companyName: z.string().trim().min(2).max(120),
  firstName: z.string().trim().min(1).max(80),
  lastName: z.string().trim().min(1).max(80),
  email: emailSchema,
  password: passwordSchema,
  acceptTerms: z.literal(true),
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({ token: z.string().min(20).max(200), password: passwordSchema });
export const acceptInviteSchema = z.object({
  token: z.string().min(20).max(200),
  firstName: z.string().trim().min(1).max(80).optional(),
  lastName: z.string().trim().min(1).max(80).optional(),
  password: passwordSchema.optional(),
});
export const switchTenantSchema = z.object({ tenantId: z.string().uuid() });

export const sessionUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  locale: z.string(),
  isSuperadmin: z.boolean(),
});
export const sessionTenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  role: z.enum(ROLES),
});
export const authResponseSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number().int(),
  user: sessionUserSchema,
  tenant: sessionTenantSchema,
  tenants: z.array(sessionTenantSchema),
  /** solo per l'app mobile (header x-kipo-client: mobile): il browser usa il cookie httpOnly */
  refreshToken: z.string().optional(),
});
export type AuthResponse = z.infer<typeof authResponseSchema>;
